import React from "react";
import "./index.css";

const CardExtrato = ({
  titulo,
  subtitulo,
  valor,
  backgroundColor,
  textColor,
  borderColor,
  tracoColor,
}) => {
  const LoadingSpinner = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
    >
      <circle
        cx="50"
        cy="50"
        r="32"
        strokeWidth="8"
        stroke="#000"
        strokeDasharray="50.26548245743669 50.26548245743669"
        fill="none"
        strokeLinecap="round"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          repeatCount="indefinite"
          dur="1s"
          keyTimes="0;1"
          values="0 50 50;360 50 50"
        />
      </circle>
    </svg>
  );

  return (
    <div
      className="cardExtract w-100 mt-2"
      style={{
        backgroundColor: backgroundColor,
        color: textColor,
        borderColor: borderColor,
      }}
    >
      <div>
        <div style={{ textAlign: "left" }}>{titulo}</div>
        {(subtitulo && <b style={{ textAlign: "left" }}>{subtitulo}</b>) || " "}
        <div
          className="tracoExtrato"
          style={{ backgroundColor: tracoColor }}
        ></div>
      </div>
      <div className="valorExtrato">
        {valor !== null && valor !== undefined ? valor : <LoadingSpinner />}
      </div>
    </div>
  );
};

export default CardExtrato;
